import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { getButtonTextByStatus, getFinalButtonTextByStatus, mapDropdownOptions } from "../../../../store/common/utils";
import { CHECK_HOUSE_CONNECTION_STATUS, popupSteps } from "../../../../store/common/constants";
import { selectIsCtnError, selectIsFttbPersonalVerificationCheckboxEnable } from "../../../../store/callbackRequest/selectors";
import { selectIsCheckboxChecked } from "../../../../store/CheckboxAgreement/selectors";
import { getModalTariffData } from "../../OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { getQueryParams } from "../../OrderTariffFormOldPopup/utils/utils";
import { selectPersonalVerificationCheckboxEnable } from "../../OrderTariffFormOldPopup/store/selectors/modal";
import { toLowerCaseFirstChar } from "./utils";
export var getOrderTariffInlineData = function getOrderTariffInlineData(state) {
  return state.modalsData.checkAddressInlinePopup || emptyObj;
};
export var selectCommonData = function selectCommonData(state) {
  var _getModalTariffData;
  return ((_getModalTariffData = getModalTariffData(state)) === null || _getModalTariffData === void 0 ? void 0 : _getModalTariffData.popupData) || emptyObj;
};
export var getCurrentFormStep = function getCurrentFormStep(state) {
  return getOrderTariffInlineData(state).currentStep;
};
export var getCheckAddressStatus = function getCheckAddressStatus(state) {
  return getOrderTariffInlineData(state).status;
};
export var getIsLoading = function getIsLoading(state) {
  return getOrderTariffInlineData(state).isLoading;
};
export var selectDropdownOptions = createSelector([getOrderTariffInlineData], function (_ref) {
  var addressSuggestions = _ref.addressSuggestions;
  return mapDropdownOptions(addressSuggestions);
});
export var getSelectedAddress = createSelector([getOrderTariffInlineData], function (_ref2) {
  var selectedAddress = _ref2.selectedAddress;
  return selectedAddress;
});
export var selectHouseInacId = function selectHouseInacId(state) {
  return getOrderTariffInlineData(state).houseInacId;
};
export var selectFiasAddress = createSelector([getSelectedAddress], function (address) {
  return address === null || address === void 0 ? void 0 : address.value;
});
export var selectIsAddressInputErrorStatus = createSelector([getOrderTariffInlineData], function (_ref3) {
  var isAddressError = _ref3.isAddressError;
  return isAddressError;
});
export var getOrderTariffInlineTexts = function getOrderTariffInlineTexts(state) {
  var _selectCommonData;
  return ((_selectCommonData = selectCommonData(state)) === null || _selectCommonData === void 0 || (_selectCommonData = _selectCommonData.texts) === null || _selectCommonData === void 0 ? void 0 : _selectCommonData.formInlinePopupTexts) || emptyObj;
};
export var selectIsLoading = function selectIsLoading(state) {
  return getOrderTariffInlineData(state).isLoading;
};
export var selectAlternativeTariffData = function selectAlternativeTariffData(state) {
  return getOrderTariffInlineData(state).tariffData || emptyObj;
};
export var selectIsCheckboxError = function selectIsCheckboxError(state) {
  return getOrderTariffInlineData(state).isCheckboxError;
};
export var shouldShowAlternativeTariffBlock = createSelector([getCheckAddressStatus], function (status) {
  return status === CHECK_HOUSE_CONNECTION_STATUS.SpeedLimit;
});
export var selectIsButtonDisabled = createSelector([selectIsCtnError, selectIsCheckboxChecked, selectIsFttbPersonalVerificationCheckboxEnable, getCurrentFormStep, selectIsCheckboxError], function (isCtnError, isCheckboxChecked, isCheckboxEnable, step, isCheckboxError) {
  if (isCheckboxEnable && isCheckboxError && step === popupSteps.addressRequestForm) {
    return isCtnError || !isCheckboxChecked;
  }
  return isCtnError;
});
export var selectRouterAvailable = function selectRouterAvailable(state) {
  return getOrderTariffInlineTexts(state).routerAvailable || emptyObj;
};
export var shouldShowAddressNotAvailableBlock = createSelector([selectRouterAvailable, getCheckAddressStatus], function (router, status) {
  return status === CHECK_HOUSE_CONNECTION_STATUS.IsNotAvailable && router;
});
export var shouldRenderModalButton = createSelector([getCurrentFormStep], function (stepNumber) {
  return stepNumber !== popupSteps.alternativeTariff && stepNumber !== popupSteps.addressNotAvailableModal;
});
export var shouldShowSecondaryButton = createSelector([getCheckAddressStatus, getCurrentFormStep], function (status, stepNumber) {
  return [CHECK_HOUSE_CONNECTION_STATUS.HasTicketOnAddress, CHECK_HOUSE_CONNECTION_STATUS.CheckAddress].includes(status) && ![popupSteps.shortSuccess, popupSteps.fail].includes(stepNumber);
});
export var shouldShowSuggestionInputText = createSelector([getCheckAddressStatus, selectIsAddressInputErrorStatus, shouldShowSecondaryButton], function (status, inputError, isSecondButton) {
  return isSecondButton && !inputError;
});
export var getActiveButtonTexts = function getActiveButtonTexts(state) {
  var _getOrderTariffInline;
  return ((_getOrderTariffInline = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline === void 0 ? void 0 : _getOrderTariffInline.buttonTexts) || emptyObj;
};
export var selectActiveButtonByStepsText = createSelector([getCheckAddressStatus, getActiveButtonTexts, getCurrentFormStep], function (status, texts, step) {
  if ([popupSteps.shortSuccess, popupSteps.fail].includes(step)) {
    return getFinalButtonTextByStatus(step, texts);
  }
  return getButtonTextByStatus(status, texts);
});
export var shouldShowPopupBlock = createSelector([getCheckAddressStatus], function (status) {
  return [CHECK_HOUSE_CONNECTION_STATUS.HasTicketOnAddress, CHECK_HOUSE_CONNECTION_STATUS.HasConnectionOnAddress, CHECK_HOUSE_CONNECTION_STATUS.NotFound].includes(status);
});
export var getInfoBlockStatusTexts = function getInfoBlockStatusTexts(state) {
  var _getOrderTariffInline2;
  return ((_getOrderTariffInline2 = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline2 === void 0 ? void 0 : _getOrderTariffInline2.infoBlockStatusTexts) || emptyObj;
};
export var selectInputErrorMessagesTexts = function selectInputErrorMessagesTexts(state) {
  var _getOrderTariffInline3;
  return ((_getOrderTariffInline3 = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline3 === void 0 ? void 0 : _getOrderTariffInline3.statusConnectionTexts) || emptyObj;
};
export var selectInputError = createSelector([selectInputErrorMessagesTexts, getCheckAddressStatus, getCurrentFormStep], function (texts, status, step) {
  return texts[toLowerCaseFirstChar(status)] || texts[step];
});
export var selectInputPlaceholder = createSelector([getOrderTariffInlineTexts], function (texts) {
  return texts.placeHolderInput;
});
export var selectLabelInputText = createSelector([getOrderTariffInlineTexts], function (texts) {
  return texts.labelInputText;
});
export var selectInputDebounce = createSelector([getOrderTariffInlineTexts], function (texts) {
  return texts.debounceTime;
});
export var getTargetTariffType = function getTargetTariffType(state) {
  return getModalTariffData(state).tariffType || emptyObj;
};
export var selectTargetTariffGroup = function selectTargetTariffGroup(state) {
  return getTargetTariffType(state).group;
};
export var selectTargetTariffLink = function selectTargetTariffLink(state) {
  return getTargetTariffType(state).tariffUrl;
};
export var getIsHighSpeedTariff = function getIsHighSpeedTariff(state) {
  return getTargetTariffType(state).isHighSpeedTariff;
};
export var selectPhoneInputTexts = function selectPhoneInputTexts(state) {
  return getOrderTariffInlineTexts(state).phoneInputTexts;
};
export var selectIsShowCheckbox = createSelector([selectPersonalVerificationCheckboxEnable, selectPhoneInputTexts], function (personalVerificationCheckboxEnable, _ref4) {
  var checkboxText = _ref4.checkboxText;
  return personalVerificationCheckboxEnable && checkboxText;
});
export var getHighSpeedAvailableFlag = createSelector([getCheckAddressStatus, getIsHighSpeedTariff], function (status, isHighSpeedTariff) {
  return isHighSpeedTariff && status === CHECK_HOUSE_CONNECTION_STATUS.IsHighSpeedAvailable;
});
export var buildOrderQueryParams = createSelector([getTargetTariffType, getSelectedAddress, getHighSpeedAvailableFlag, selectHouseInacId, getCheckAddressStatus], function (tariffData, userData, isHighSpeedAvailable, houseInacId, status) {
  return getQueryParams(_objectSpread(_objectSpread({
    inacId: tariffData.inacId,
    houseInacId: houseInacId
  }, userData), {}, {
    isHighSpeedAvailable: isHighSpeedAvailable,
    status: status
  }));
});